(function () {
  'use strict';
  if (window.yueluInquiryHeaderLoaded) return;
  window.yueluInquiryHeaderLoaded = true;

  var storageKey = 'yuelu:inquiry:v1';
  var instances = new Map();
  var maximumQuantity = 1000000;
  var lastReadComplete = true;

  function readSelections() {
    lastReadComplete = true;
    if (window.YueluInquiryList) return window.YueluInquiryList.read();
    var saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
    if (!saved || saved.version !== 1 || !Array.isArray(saved.items)) return [];
    var ids = new Set();
    var items = saved.items.filter(function (item) {
      var id = item && String(item.variantId);
      if (!item || !/^\d{1,20}$/.test(id) || ids.has(id) || !item.title || !item.url) return false;
      if (item.quantity !== null && validQuantity(item.quantity) === undefined) return false;
      ids.add(id);
      return true;
    });
    lastReadComplete = items.length === saved.items.length;
    return items;
  }

  function validQuantity(value) {
    var raw = String(value);
    var amount = Number(raw);
    return /^\d+$/.test(raw) && Number.isSafeInteger(amount) && amount >= 1 && amount <= maximumQuantity ? amount : undefined;
  }

  function safeUrl(value, sameOrigin) {
    try {
      var url = new URL(String(value || ''), location.origin);
      if (!['http:', 'https:'].includes(url.protocol) || (sameOrigin && url.origin !== location.origin)) return '';
      return url.href;
    } catch (_) { return ''; }
  }

  function previewUrl(value) {
    var url = new URL(value, location.origin);
    var preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }

  function textElement(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    node.textContent = String(text || '');
    return node;
  }

  function initialize(root) {
    if (instances.has(root)) return;
    var trigger = root.querySelector('[data-inquiry-preview-trigger]');
    var panel = root.querySelector('[data-inquiry-preview]');
    var list = root.querySelector('[data-inquiry-preview-items]');
    var count = root.querySelector('[data-inquiry-preview-count]');
    var empty = root.querySelector('[data-inquiry-preview-empty]');
    var status = root.querySelector('[data-inquiry-preview-status]');
    if (!trigger || !panel || !list || !count || !empty || !status) return;
    var pricingFooter = panel.querySelector('[data-inquiry-preview-pricing-footer]');
    var subtotal = panel.querySelector('[data-inquiry-preview-subtotal]');

    var controller = new AbortController();
    var options = { signal: controller.signal };
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    var smallScreen = window.matchMedia('(max-width: 749px)');
    var rows = new Map();
    var drafts = new Map();
    var currentItems = new Map();
    var closeTimer;
    var focusTimer;
    var pinned = false;
    var suppressFocusOpen = false;
    var serial = 0;
    var pricingTimer = null;
    var pricingTimeout = null;
    var pricingController = null;
    var pricingGeneration = 0;
    var pricingRequestKey = null;
    var pricingCache = null;
    var selectionsAvailable = true;
    var disposed = false;

    function announce(message, error) {
      status.textContent = message || '';
      status.hidden = !message;
      status.classList.toggle('is-error', Boolean(error));
    }

    function rowError(record, message) {
      record.error.textContent = message || '';
      record.error.hidden = !message;
      record.input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function makeRow(id) {
      var row = textElement('li', 'yuelu-inquiry-preview__item', '');
      row.dataset.inquiryPreviewRow = id;
      var link = textElement('a', 'yuelu-inquiry-preview__product', '');
      link.dataset.inquiryPreviewVariant = id;
      var thumbnail = textElement('span', 'yuelu-inquiry-preview__thumbnail', '');
      var details = textElement('div', 'yuelu-inquiry-preview__details', '');
      var title = textElement('a', 'yuelu-inquiry-preview__title', '');
      var variant = textElement('a', 'yuelu-inquiry-preview__variant', '');
      link.append(thumbnail);

      var editor = textElement('div', 'yuelu-inquiry-preview__editor', '');
      var label = textElement('label', 'yuelu-inquiry-preview__quantity-label visually-hidden', panel.dataset.quantityLabel);
      var inputId = panel.id + '-quantity-' + (++serial);
      label.htmlFor = inputId;
      var control = textElement('div', 'yuelu-inquiry-preview__quantity-control', '');
      var decrease = textElement('button', 'yuelu-inquiry-preview__step', '−');
      decrease.type = 'button';
      decrease.dataset.inquiryPreviewStep = '-1';
      decrease.setAttribute('aria-label', panel.dataset.decreaseLabel);
      var input = document.createElement('input');
      input.id = inputId;
      input.className = 'yuelu-inquiry-preview__input';
      input.type = 'text';
      input.inputMode = 'numeric';
      input.pattern = '[0-9]+';
      input.maxLength = 7;
      input.autocomplete = 'off';
      input.dataset.inquiryPreviewQuantity = id;
      input.setAttribute('aria-label', panel.dataset.quantityLabel);
      input.setAttribute('aria-describedby', inputId + '-error');
      input.setAttribute('aria-invalid', 'false');
      var increase = textElement('button', 'yuelu-inquiry-preview__step', '+');
      increase.type = 'button';
      increase.dataset.inquiryPreviewStep = '1';
      increase.setAttribute('aria-label', panel.dataset.increaseLabel);
      control.append(decrease, input, increase);
      var quantityGroup = textElement('div', 'yuelu-inquiry-preview__quantity-group', '');
      quantityGroup.append(control);
      var remove = textElement('button', 'yuelu-inquiry-preview__remove', panel.dataset.removeLabel);
      remove.type = 'button';
      remove.dataset.inquiryPreviewRemove = id;
      var error = textElement('p', 'yuelu-inquiry-preview__error', '');
      error.id = inputId + '-error';
      error.hidden = true;
      error.setAttribute('aria-live', 'polite');
      var prices = textElement('div', 'yuelu-inquiry-preview__prices', '');
      var unitPriceGroup = textElement('span', 'yuelu-inquiry-preview__unit-price', '');
      var unitPrice = textElement('span', 'yuelu-inquiry-preview__price-value', panel.dataset.pricingPending);
      unitPrice.dataset.inquiryPreviewUnitPrice = id;
      unitPriceGroup.append(textElement('span', 'yuelu-inquiry-preview__price-label', panel.dataset.unitPriceLabel), unitPrice);
      var lineTotalGroup = textElement('span', 'yuelu-inquiry-preview__line-total', '');
      var lineTotal = textElement('strong', 'yuelu-inquiry-preview__price-value', panel.dataset.pricingPending);
      lineTotal.dataset.inquiryPreviewLineTotal = id;
      lineTotalGroup.append(textElement('span', 'yuelu-inquiry-preview__price-label', panel.dataset.amountLabel), lineTotal);
      prices.append(unitPriceGroup, lineTotalGroup);
      editor.append(label, quantityGroup, remove);
      details.append(title, variant, editor, prices);
      row.append(link, details, error);
      return { row: row, link: link, thumbnail: thumbnail, title: title, variant: variant, control: control, input: input, decrease: decrease, increase: increase, remove: remove, error: error, unitPrice: unitPrice, lineTotal: lineTotal, item: null };
    }

    function updateQuantityWidth(record) {
      record.control.classList.toggle('is-wide', String(record.input.value).trim().length >= 5);
    }

    function fillRow(record, item) {
      record.item = item;
      record.row.classList.remove('is-removed');
      record.link.href = previewUrl(safeUrl(item.url, true) || trigger.href);
      record.title.textContent = String(item.title).slice(0, 500);
      record.title.href = record.link.href;
      record.title.title = record.title.textContent;
      record.title.setAttribute('aria-label', record.title.textContent);
      record.variant.textContent = item.variantTitle && item.variantTitle !== 'Default Title' ? String(item.variantTitle).slice(0, 500) : panel.dataset.standardOption;
      var description = record.title.textContent + ' — ' + record.variant.textContent;
      record.link.title = description;
      record.link.setAttribute('aria-label', description);
      record.variant.href = record.link.href;
      record.variant.setAttribute('aria-label', description);
      record.input.setAttribute('aria-label', panel.dataset.quantityLabel + ': ' + description);
      record.decrease.setAttribute('aria-label', panel.dataset.decreaseLabel + ': ' + description);
      record.increase.setAttribute('aria-label', panel.dataset.increaseLabel + ': ' + description);
      record.remove.setAttribute('aria-label', panel.dataset.removeLabel + ': ' + description);
      var imageUrl = item.image ? safeUrl(item.image, false) : '';
      if (record.thumbnail.dataset.image !== imageUrl) {
        record.thumbnail.dataset.image = imageUrl;
        record.thumbnail.replaceChildren();
        if (imageUrl) {
          var image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.width = 56;
          image.height = 56;
          image.loading = 'lazy';
          image.addEventListener('error', function () { image.hidden = true; }, { once: true });
          record.thumbnail.appendChild(image);
        }
      }
      var id = String(item.variantId);
      if (!drafts.has(id)) {
        record.input.value = item.quantity === null ? '' : String(item.quantity);
        rowError(record, '');
      }
      record.input.placeholder = panel.dataset.quantityPending;
      record.input.readOnly = false;
      updateQuantityWidth(record);
      var amount = validQuantity(record.input.value);
      record.decrease.disabled = amount === 1;
      record.increase.disabled = amount === maximumQuantity;
    }

    function cancelPricing(clearCache) {
      pricingGeneration += 1;
      clearTimeout(pricingTimer);
      clearTimeout(pricingTimeout);
      pricingTimer = null;
      pricingTimeout = null;
      if (pricingController) pricingController.abort();
      pricingController = null;
      pricingRequestKey = null;
      if (clearCache) pricingCache = null;
    }

    function showPricingState(state) {
      var message = state === 'loading' ? panel.dataset.pricingLoading : panel.dataset.pricingPending;
      rows.forEach(function (record) { record.unitPrice.textContent = message; record.lineTotal.textContent = message; });
      if (subtotal) { subtotal.textContent = message; subtotal.setAttribute('aria-busy', String(state === 'loading')); }
      panel.dataset.pricingState = state;
      if (pricingFooter) pricingFooter.hidden = rows.size === 0;
    }

    function pricingProjection() {
      if (!selectionsAvailable || currentItems.size < 1 || currentItems.size > 50 || rows.size !== currentItems.size) return null;
      var products = [];
      var invalid = false;
      currentItems.forEach(function (item, id) {
        var record = rows.get(id);
        var raw = drafts.has(id) ? drafts.get(id) : item.quantity;
        var amount = raw === null ? undefined : validQuantity(raw);
        if (!record || !record.error.hidden || amount === undefined) { invalid = true; return; }
        products.push({ variantId: id, quantity: amount });
      });
      if (invalid) return null;
      products.sort(function (left, right) { return left.variantId.localeCompare(right.variantId); });
      return { products: products, key: JSON.stringify(products) };
    }

    function money(value) {
      if (typeof value !== 'string' || !/^\d{1,12}\.\d{2}$/.test(value)) return null;
      var parts = value.split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1] + ' USD';
    }

    function applyPricing(pricing, projection) {
      if (!pricing || typeof pricing.pricingComplete !== 'boolean' || !['USD', null].includes(pricing.currency) || !Array.isArray(pricing.lines) || pricing.lines.length !== projection.products.length) return false;
      var totalText = money(pricing.goodsSubtotal);
      if (pricing.goodsSubtotal !== null && totalText === null) return false;
      var expected = new Map(projection.products.map(function (item) { return [item.variantId, item.quantity]; }));
      var seen = new Set();
      var formatted = [];
      pricing.lines.forEach(function (line) {
        if (!line || typeof line !== 'object') return;
        var unitText = money(line.unitPrice);
        var lineText = money(line.lineTotal);
        var unavailable = line.unitPrice === null && line.lineTotal === null;
        if (seen.has(line.variantId) || expected.get(line.variantId) !== line.quantity || (!unavailable && (unitText === null || lineText === null))) return;
        seen.add(line.variantId);
        formatted.push({ id: line.variantId, unit: unitText, total: lineText, known: !unavailable });
      });
      if (formatted.length !== projection.products.length) return false;
      var complete = formatted.every(function (line) { return line.known; });
      if (pricing.pricingComplete !== complete || (complete && (pricing.currency !== 'USD' || totalText === null)) || (!complete && pricing.goodsSubtotal !== null)) return false;
      if (formatted.some(function (line) { return line.known; }) && pricing.currency !== 'USD') return false;
      formatted.forEach(function (line) {
        var record = rows.get(line.id);
        record.unitPrice.textContent = line.known ? line.unit : panel.dataset.pricingPending;
        record.lineTotal.textContent = line.known ? line.total : panel.dataset.pricingPending;
      });
      if (subtotal) { subtotal.textContent = complete ? totalText : panel.dataset.pricingPending; subtotal.setAttribute('aria-busy', 'false'); }
      if (pricingFooter) pricingFooter.hidden = false;
      panel.dataset.pricingState = complete ? 'complete' : 'partial';
      return true;
    }

    function refreshPricing(force) {
      if (disposed || panel.hidden || !pricingFooter || !subtotal) return;
      var projection = pricingProjection();
      if (!projection) { cancelPricing(true); showPricingState('pending'); return; }
      if (!force && pricingRequestKey === projection.key && (pricingTimer !== null || pricingController)) return;
      if (!force && pricingCache && pricingCache.key === projection.key && pricingCache.expires > Date.now()) {
        if (pricingRequestKey && pricingRequestKey !== projection.key) cancelPricing(false);
        if (applyPricing(pricingCache.pricing, projection)) return;
      }
      cancelPricing(false);
      showPricingState('loading');
      pricingRequestKey = projection.key;
      var version = pricingGeneration;
      pricingTimer = setTimeout(async function () {
        pricingTimer = null;
        if (disposed || panel.hidden || version !== pricingGeneration) return;
        var requestController = new AbortController();
        pricingController = requestController;
        pricingTimeout = setTimeout(function () {
          if (version !== pricingGeneration) return;
          cancelPricing(true);
          showPricingState('pending');
        }, 10000);
        try {
          if (!window.YueluInquiryPricing || typeof window.YueluInquiryPricing.request !== 'function') throw new Error();
          var pricing = await window.YueluInquiryPricing.request(projection.products, { signal: requestController.signal });
          var current = pricingProjection();
          if (disposed || panel.hidden || version !== pricingGeneration || !current || current.key !== projection.key) return;
          if (!applyPricing(pricing, current)) { pricingCache = null; showPricingState('pending'); return; }
          pricingCache = { key: current.key, pricing: pricing, expires: Date.now() + 5000 };
        } catch (_) {
          if (!disposed && !panel.hidden && version === pricingGeneration) { pricingCache = null; showPricingState('pending'); }
        } finally {
          if (version === pricingGeneration) {
            clearTimeout(pricingTimeout);
            pricingTimeout = null;
            pricingController = null;
            pricingRequestKey = null;
          }
        }
      }, 250);
    }

    function render() {
      var items;
      try { items = readSelections(); }
      catch (error) {
        selectionsAvailable = false;
        cancelPricing(true);
        showPricingState('pending');
        announce(window.YueluInquiryList && error.message || panel.dataset.unavailableMessage, true);
        return;
      }
      selectionsAvailable = lastReadComplete;
      currentItems = new Map(items.map(function (item) { return [String(item.variantId), item]; }));
      var active = document.activeElement;
      var restoreFocus = list.contains(active);
      var selection = restoreFocus && active.matches('input') ? [active.selectionStart, active.selectionEnd, active.selectionDirection] : null;
      var previousScrollTop = list.scrollTop;
      var desiredRows = [];
      items.slice().reverse().forEach(function (item) {
        var id = String(item.variantId);
        var record = rows.get(id);
        if (!record) { record = makeRow(id); rows.set(id, record); }
        fillRow(record, item);
        desiredRows.push(record.row);
      });
      rows.forEach(function (record, id) {
        if (currentItems.has(id)) return;
        if (drafts.has(id)) {
          record.row.classList.add('is-removed');
          record.input.readOnly = true;
          record.decrease.disabled = true;
          record.increase.disabled = true;
          rowError(record, panel.dataset.removedNotice);
          desiredRows.push(record.row);
        } else {
          record.row.remove();
          rows.delete(id);
        }
      });
      desiredRows.forEach(function (row, index) {
        if (list.children[index] !== row) list.insertBefore(row, list.children[index] || null);
      });
      list.scrollTop = previousScrollTop;
      count.textContent = panel.dataset.countTemplate.replaceAll('__count__', String(items.length));
      empty.hidden = desiredRows.length > 0;
      root.querySelectorAll('[data-inquiry-count]').forEach(function (badge) {
        badge.textContent = String(items.length);
        badge.hidden = items.length === 0;
      });
      if (restoreFocus && !panel.hidden) {
        if (active.isConnected) {
          if (document.activeElement !== active) active.focus({ preventScroll: true });
          if (selection) active.setSelectionRange(selection[0], selection[1], selection[2]);
        } else trigger.focus({ preventScroll: true });
      }
      refreshPricing(false);
    }

    function commit(id, raw) {
      var record = rows.get(id);
      if (!record) return false;
      var amount = validQuantity(raw);
      drafts.set(id, String(raw));
      record.input.value = String(raw);
      updateQuantityWidth(record);
      if (amount === undefined) { rowError(record, panel.dataset.quantityError); refreshPricing(false); return false; }
      if (!currentItems.has(id)) { rowError(record, panel.dataset.removedNotice); refreshPricing(false); return false; }
      try {
        if (!window.YueluInquiryList) throw new Error(panel.dataset.unavailableMessage);
        window.YueluInquiryList.setQuantity(id, amount);
        drafts.delete(id);
        rowError(record, '');
        announce(panel.dataset.updatedMessage, false);
        render();
        return true;
      } catch (error) { rowError(record, error.message || panel.dataset.unavailableMessage); refreshPricing(false); return false; }
    }

    function positionPanel() {
      panel.style.maxWidth = Math.max(0, document.documentElement.clientWidth - 32) + 'px';
      panel.style.transform = '';
      var bounds = panel.getBoundingClientRect();
      panel.style.setProperty('--yuelu-inquiry-preview-space', Math.max(0, document.documentElement.clientHeight - Math.max(16, bounds.top) - 16) + 'px');
      var viewportRight = document.documentElement.clientWidth - 16;
      var offset = bounds.left < 16 ? 16 - bounds.left : bounds.right > viewportRight ? viewportRight - bounds.right : 0;
      if (offset) panel.style.transform = 'translateX(' + offset + 'px)';
    }

    function open(pin) {
      clearTimeout(closeTimer);
      if (document.querySelector('dialog[open]')) return;
      if (pin) pinned = true;
      if (!panel.hidden) return;
      render();
      panel.hidden = false;
      positionPanel();
      refreshPricing(true);
      trigger.setAttribute('aria-expanded', 'true');
      document.dispatchEvent(new CustomEvent('yuelu:inquiry:preview-open', { detail: { root: root } }));
    }

    function close(restoreFocus) {
      clearTimeout(closeTimer);
      pinned = false;
      var wasOpen = !panel.hidden;
      panel.hidden = true;
      cancelPricing(true);
      showPricingState('pending');
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus && document.activeElement !== trigger) {
        suppressFocusOpen = true;
        trigger.focus({ preventScroll: true });
      }
      if (wasOpen) document.dispatchEvent(new CustomEvent('yuelu:inquiry:preview-close', { detail: { root: root } }));
    }

    root.addEventListener('pointerenter', function (event) {
      if (finePointer.matches && !smallScreen.matches && event.pointerType !== 'touch') open(false);
    }, options);
    root.addEventListener('pointerleave', function (event) {
      if (!finePointer.matches || smallScreen.matches || event.pointerType === 'touch' || pinned) return;
      closeTimer = setTimeout(function () { if (!pinned && !root.contains(document.activeElement)) close(false); }, 220);
    }, options);
    root.addEventListener('focusin', function (event) {
      clearTimeout(closeTimer);
      if (suppressFocusOpen) { suppressFocusOpen = false; return; }
      if (panel.contains(event.target)) pinned = true;
    }, options);
    root.addEventListener('focusout', function () {
      clearTimeout(focusTimer);
      focusTimer = setTimeout(function () { if (!root.contains(document.activeElement)) close(false); }, 0);
    }, options);
    trigger.addEventListener('click', function () {
      close(false);
    }, options);
    trigger.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' && !smallScreen.matches) {
        event.preventDefault();
        open(true);
        panel.querySelector('button, a, input')?.focus({ preventScroll: true });
      }
    }, options);
    list.addEventListener('input', function (event) {
      var input = event.target.closest('[data-inquiry-preview-quantity]');
      if (!input) return;
      var id = input.dataset.inquiryPreviewQuantity;
      drafts.set(id, input.value);
      var record = rows.get(id);
      updateQuantityWidth(record);
      rowError(record, '');
      record.decrease.disabled = validQuantity(input.value) === 1;
      record.increase.disabled = validQuantity(input.value) === maximumQuantity;
      announce('', false);
      refreshPricing(false);
    }, options);
    list.addEventListener('change', function (event) {
      var input = event.target.closest('[data-inquiry-preview-quantity]');
      if (input) commit(input.dataset.inquiryPreviewQuantity, input.value);
    }, options);
    list.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (!button) return;
      var row = button.closest('[data-inquiry-preview-row]');
      var id = row && row.dataset.inquiryPreviewRow;
      var record = rows.get(id);
      if (!record) return;
      pinned = true;
      if (button.hasAttribute('data-inquiry-preview-step')) {
        var amount = validQuantity(record.input.value);
        if (amount === undefined) { rowError(record, panel.dataset.quantityError); refreshPricing(false); record.input.focus(); return; }
        commit(id, String(amount + Number(button.dataset.inquiryPreviewStep)));
      } else if (button.hasAttribute('data-inquiry-preview-remove')) {
        try {
          if (currentItems.has(id)) {
            if (!window.YueluInquiryList) throw new Error(panel.dataset.unavailableMessage);
            window.YueluInquiryList.remove(id);
          }
          drafts.delete(id);
          render();
          announce(panel.dataset.removedMessage, false);
          var nextInput = list.querySelector('input');
          (nextInput || root.querySelector('[data-inquiry-preview-close]')).focus({ preventScroll: true });
        } catch (error) { rowError(record, error.message || panel.dataset.unavailableMessage); refreshPricing(false); }
      }
    }, options);
    list.addEventListener('keydown', function (event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      if (event.target.matches('input')) {
        if (event.key === 'Enter') { event.preventDefault(); commit(event.target.dataset.inquiryPreviewQuantity, event.target.value); }
        return;
      }
      if (event.target.closest('button, a')) return;
      var movement = { ArrowDown: 64, ArrowUp: -64, PageDown: list.clientHeight, PageUp: -list.clientHeight }[event.key];
      if (movement !== undefined) {
        event.preventDefault();
        list.scrollBy({ top: movement, behavior: 'auto' });
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        list.scrollTo({ top: event.key === 'Home' ? 0 : list.scrollHeight, behavior: 'auto' });
      }
    }, options);
    root.querySelector('[data-inquiry-preview-close]')?.addEventListener('click', function () { close(true); }, options);
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || panel.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      close(root.contains(document.activeElement));
    }, options);
    document.addEventListener('pointerdown', function (event) {
      if (!root.contains(event.target)) close(false);
      else if (panel.contains(event.target)) pinned = true;
    }, options);
    document.addEventListener('yuelu:quick-list:open', function () { close(false); }, options);
    document.addEventListener('yuelu:inquiry:success-open', function () { close(false); }, options);
    window.addEventListener('resize', function () { if (!panel.hidden) positionPanel(); }, options);

    instances.set(root, { render: render, dispose: function () { disposed = true; clearTimeout(closeTimer); clearTimeout(focusTimer); cancelPricing(true); controller.abort(); } });
    render();
  }

  function initializeAll() {
    instances.forEach(function (instance, root) {
      if (!root.isConnected) { instance.dispose(); instances.delete(root); }
    });
    document.querySelectorAll('[data-inquiry-header]').forEach(initialize);
  }

  function refresh() {
    initializeAll();
    instances.forEach(function (instance) { instance.render(); });
  }

  window.addEventListener('storage', function (event) { if (event.key === storageKey || event.key === null) refresh(); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('yuelu:inquiry:change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (instance, root) {
      if (event.target.contains(root)) { instance.dispose(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
}());

